import data from "../../shared/sharedData";

export default {
  name: "Attorney or Agent Information (if applicable)",
  pageInfo: {
    text: "The attorney/agent information in this Section, specifically the name, telephone number, and email address, must be different from the employer’s point of contact information in Section B, except when an attorney listed in this Section is an employee of the employer.",
    coloring: "grey",
  },
  prefix: "D",
  sections: [
    {
      fields: [
        {
          widget: "inlinePrefiller",
          prefillLabel:
            "Select an Attorney/Agent profile to populate this section (optional)",
          prefill: {
            schema: "agent-attorney-9141",
            type: "agent-attorney-individs",
            formName: "9141",
            formSection: "D",
          },
        },
        {
          isGroup: {
            code: "D.1",
            machine_name: "attyRepresentType",
            label: `Indicate the type of representation for the employer in the filing of this application * If D.1 is “Attorney” or “Agent” the remainder of this section is required.`,
            tooltip:
              "Identify whether an attorney or agent is filing this application on behalf of the employer. If this application is not filed by either an attorney or agent for the employer, check “None.” Mark only one box. ",
            coloring: "none",
            //required: true,
            fields: [
              {
                widget: "radio",
                choice: "Attorney",
                value: "Attorney",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Agent",
                value: "Agent",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "None",
                value: "None",
                validate: ["required"],
                clearSchema: [
                  "attyLastname",
                  "attyFirstname",
                  "attyMiddlename",
                  "attyAddr1",
                  "attyAddr2",
                  "attyCountry",
                  "attyCity",
                  "attyState",
                  "attyProvince",
                  "attyPostcode",
                  "attyPhone",
                  "attyPhoneext",
                  "attyEmail",
                  "attyBizname",
                  "attyFein",
                ],
              },
            ],
          },
        },
      ],
    },
    {
      isVisible: {
        when: "attyRepresentType",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      fields: [
        {
          code: "D.2",
          machine_name: "attyLastname",
          widget: "text",
          label: "Attorney or agent's last (family) name",
          validate: [
            "required",

            {
              minLength: 2,
              message:
                "Attorney or agent's last name must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          tooltip: "Enter the last (family) name of the attorney or agent.",
        },
        {
          code: "D.3",
          machine_name: "attyFirstname",
          widget: "text",
          label: "First (given) name",
          validate: [
            "required",
            {
              minLength: 2,
              message: "First Name must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          tooltip: "Enter the first (given) name of the attorney or agent.",
        },
        {
          code: "D.4",
          machine_name: "attyMiddlename",
          widget: "text",
          label: "Middle name(s)",
          maxLength: 35,
          tooltip: "Enter the middle name of the attorney or agent.",
        },
      ],
    },
    {
      isVisible: {
        when: "attyRepresentType",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      fields: [
        {
          code: "D.5",
          machine_name: "attyAddr1",
          widget: "text",
          label: "Address 1",
          validate: [
            "required",
            {
              minLength: 2,
              message: "Address 1 must contain at least 2 characters.",
            },
          ],
          maxLength: 60,
          tooltip:
            "Enter the business street address of the attorney or agent.",
        },
        {
          code: "D.6",
          machine_name: "attyAddr2",
          widget: "text",
          label:
            "<span>Address 2 <i>(apartment/suite/floor and number)</i></span>",
          maxLength: 60,
          tooltip:
            "If additional space is needed for the street address, use this line to complete the attorney or agent’s street address.",
        },
        {
          code: "D.10",
          machine_name: "attyCountry",
          widget: "select",
          label: "Country",
          selection: data.country,
          validate: ["required"],
          clearSchema: ["attyState", "attyProvince"],
          tooltip:
            "Enter the country of the attorney or agent. If the city and country are the same, the name <u>must</u> be entered in <u>both</u> fields.",
        },
        {
          code: "D.7",
          machine_name: "attyCity",
          widget: "text",
          label: "City",
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          disabled: true,
          disableWhenField: "attyCountry",
          tooltip:
            "Enter the city of the attorney or agent. If the city and country are the same, the name must still be entered in both fields.",
        },
        {
          code: "D.8",
          machine_name: "attyState",
          widget: "select",
          label: "State §",
          selection: data.state,
          required: true,
          disabled: true,
          disableWhenField: "attyCountry",
          state: true,
          maxLength: 35,
          validate: [
            {
              isRequired: "attyCountry",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
          ],
          isVisible: {
            when: "attyCountry",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "||",
            hideStyles: true,
          },
          tooltip:
            "Enter the state of the attorney or agent. State is required if the country is United States.",
        },
        {
          code: "D.11",
          machine_name: "attyProvince",
          widget: "text",
          label: "Province (if applicable)",
          maxLength: 25,
          validate: [
            //"required",
            {
              isRequired: "attyCountry",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "CANADA",
              },
            },
            {
              minLength: 5,
              message: "Province must contain at least 5 characters.",
            },
          ],
          isVisible: {
            when: "attyCountry",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "!==",
            hideStyles: true,
          },
          tooltip:
            "Enter the province of the attorney or agent, if applicable.",
        },
        {
          code: "D.9",
          machine_name: "attyPostcode",
          widget: "text",
          label: "Postal code",
          validate: [
            //"postal",
            {
              postalCountry: "attyCountry",
              needsFieldValues: true,
              extraData: {
                valueOf: "attyCountry",
              },
            },
            {
              isRequired: "attyCountry",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
            //{ message: "This is not a valid Postal Code." },
          ],
          disabled: true,
          disableWhenField: "attyCountry",
          maxLength: 10,
          tooltip: "Enter the postal (ZIP) code of the attorney or agent.",
        },
      ],
    },
    {
      isVisible: {
        when: "attyRepresentType",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      fields: [
        {
          code: "D.12",
          machine_name: "attyPhone",
          widget: "phone",
          label: "Telephone number",
          validate: ["required", "phone"],
          tooltip:
            "Enter the area code and business telephone number of the attorney or agent. Include country code, if applicable.",
        },
        {
          code: "D.13",
          machine_name: "attyPhoneext",
          widget: "text",
          label: "Extension",
          validate: ["number"],
          parse: "positiveWholeNumber", //don't allow decimal Number and negative number
          maxLength: 4,
          tooltip:
            "Enter the extension of the telephone number of the attorney or agent, if applicable.",
        },
        {
          code: "D.14",
          machine_name: "attyEmail",
          widget: "text",
          label: "Law firm/business e-mail address",
          validate: [
            "required",
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
          ],
          maxLength: 70,
          warning: {
            text: "The employer point of contact must be different from the agent/attorney, unless the agent/attorney is an employee of the employer.",
            isVisible: {
              when: "attyLastname attyFirstname attyMiddlename attyPhone attyEmail",
              is: [
                "requestorPocLastName",
                "requestorPocFirstName",
                "requestorPocMiddleName",
                "requestorPocPhone",
                "requestorPocEmail",
              ],
              operator: "conditionTwoSetsMatchAll",
            },
          },
          tooltip:
            "Enter the business email address of the attorney/agent in the format name@emailaddress.top-level domain. The email entered in this field must be the one regularly used by the attorney/agent’s point of contact to send and receive electronic communications from the Department with respect to the processing of this application. If the attorney/agent’s point of contact does not possess a business email address, please enter “N/A.”",
        },
        {
          code: "D.15",
          machine_name: "attyBizname",
          widget: "text",
          label: "Law firm/business name",
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Law Firm/Business Name must contain at least 5 characters",
            },
          ],
          maxLength: 120,
          tooltip: "Enter the attorney/agent law firm or business name.",
        },
        {
          code: "D.16",
          machine_name: "attyFein",
          widget: "text",
          label: "Law firm/business FEIN",
          disableWhenField: {},
          validate: [
            {
              isRequired: "attyCountry",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
            "fein",
            { minLength: 10, message: "This is not a valid FEIN" },
            {
              FEINPrefixValidator: "attyFein",
              needsFieldValues: true,
              message:
                "Please enter a valid 1st 2 digits of the Agent or Attorney's 9 digit Federal Employer Identification number(FEIN).",
              extraData: {
                condition: {
                  when: "attyCountry",
                  value: "UNITED STATES OF AMERICA",
                },
              },
            },
          ],
          parse: "fein",
          maxLength: 10,
          tooltip:
            "Enter the attorney/agent’s law firm or business nine-digit FEIN as assigned by the IRS, if applicable.",
        },
      ],
    },
  ],
};
